import { Component, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import 'jquery-slimscroll';

import {DemoService} from '../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
// // import { ThrowStmt } from '@angular/compiler';


import { AdminGuard } from './../../../_guards/admin.guard';
import { ClientGuard } from './../../../_guards/client.guard';
import { StaffGuard } from './../../../_guards/staff.guard';
import { ManagerGuard } from './../../../_guards/manager.guard';

import { User } from '../../../_models/index';


import { Brand } from './../../../api/brand';
import { MysqlService } from './../../../services/mysql.service';


declare var jQuery:any;

@Component({
  selector: 'navigationManager',
  templateUrl: 'navigationManager.template.html'
})

export class NavigationManagerComponent {

  brandMysql: any;
  currentUserID: any;
  currentPhoto: any;
  currentAccessLevel: any;
  currentBrandID: any;
  currentUser: User;
  users: User[] = [];



  constructor( public router: Router,
    private _mysqlService: MysqlService, private route: ActivatedRoute,
    public _demoService: DemoService
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser') as string);
    this.currentBrandID = this.currentUser.brand_id;
    this.currentAccessLevel = this.currentUser.access_level;
    this.currentPhoto = this.currentUser.access_level;
    this.currentUserID = this.currentUser.user_id;
    this.getBrandMysql(this.currentBrandID);

  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {

    jQuery('#side-menu').metisMenu();

    if (jQuery('body').hasClass('fixed-sidebar')) {
      jQuery('.sidebar-collapse').slimscroll({
        height: '100%'
      });
    }
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }





  private getBrandMysql(brand_id) {
    this._mysqlService.getMysqlBrandDatas(brand_id)
      .subscribe(
        res => this.brandMysql = res,
        err => console.error(err.status)
      );
  }




}
